import { StatusApi } from '@voladeum/client';
import { v4 as uuidv4 } from 'uuid';

import { Status } from './types';

export const normalizeStatuses = (data: StatusApi[]): Status[] =>
  data.map((d) => normalizeStatus(d));

export const normalizeStatus = (row: StatusApi): Status => {
  return { ...row, uuid: uuidv4() };
};
